export default __webpack_public_path__ + "static/media/2_0146.246af503.webp";